## `components/ErrorState.vue` (driven by `useLoadingError`)
<template>
    <div class="enhanced-error-container text-center">
        <div class="error-content">
            <div class="error-header">
                <h4>Something went wrong</h4>
            </div>
            <div class="error-message">
                <h5>{{ message }}</h5>
            </div>

            <!-- <div v-if="details" class="error-details">
                <button class="details-toggle" @click="show = !show">
                    <i :class="show ? 'fas fa-chevron-up' : 'fas fa-chevron-down'" />
                    {{ show ? 'Hide' : 'Show' }} Details & Solutions
                </button>
                <div v-show="show" class="details-content">
                    <h4>Possible solutions:</h4>
                    <ul class="solutions-list">
                        <li v-for="s in details.suggestions" :key="s"><i class="fas fa-lightbulb" /> {{ s }}</li>
                    </ul>
                </div>
            </div> -->

            <div class="error-actions">
                <button class="ube-btn secondary" @click="$emit('back')">
                    <i class="fas fa-arrow-left" /> Go Back
                </button>
                <button v-if="canRetry" class="ube-btn primary" @click="$emit('retry')">
                    <i class="fas fa-redo" /> Try Again
                </button>
                <button v-else class="ube-btn primary" @click="$emit('reset')">
                    <i class="fas fa-home" /> Start Over
                </button>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';

defineProps<{ message: string; details?: { type: string; suggestions: string[] } | null; canRetry: boolean }>();
const show = ref(false);
</script>